import { Link } from 'react-router-dom';
import StatusPill from './Utils/StatusPill';
import { Button, Image } from 'antd';
import { useState } from 'react';
import Modal from 'antd/lib/modal/Modal';
import ExclamationCircleOutlined from '@ant-design/icons/lib/icons/ExclamationCircleOutlined';
import WarningModal from './WarningModal';

const RenderSideItem = ({
    iconSource,
    title,
    showStatus = false,
    status,
    link = '',
    onClick
}: {
    iconSource: string;
    title: string;
    showStatus?: boolean;
    status?: boolean;
    link?: string;
    onClick?: () => void;
}) => {
    return (
        <div className="display-flex align-items-center gap-2">
            <Image width={'0.90em'} preview={false} src={iconSource} />
            <Link to={link} onClick={onClick} className='hover-underline text-nowrap'>
                <div className={`${showStatus ? "me-0" : "me-0"} cursor-pointer fs-7 side-item-link-color`}>
                    {title}
                </div>
            </Link>
            {showStatus && (
                <StatusPill
                    className={status ? 'allergy-complete' : 'allergy-pending'}
                    title={status ? 'complete' : 'incomplete'}
                />
            )}
        </div>

        
    );
};

export default RenderSideItem;
